import GlobalOverlayProvider from './GlobalOverlayProvider'

export default GlobalOverlayProvider
